// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/pagination/style/index.css
// module id = 831
// module chunks = 0